// src/app/store/user/user.reducer.ts
import { createReducer, on } from '@ngrx/store';
import * as UserActions from '../users/users.actions';
import { User } from '../../core/models/user.model';

export interface UserState {
    users: User[];
    loading: boolean;
    error: string | null;
    total: number; // Add this property
}

const initialState: UserState = {
    users: [],
    loading: false,
    error: null,
    total: 0 // Initialize total
};

export const userReducer = createReducer(
    initialState,

    // Load Users
    on(UserActions.loadUsers, (state) => ({
        ...state,
        loading: true,
        error: null
    })),
    on(UserActions.loadUsersSuccess, (state, { users, total }) => ({
        ...state,
        users,
        total, // Add this
        loading: false
    })),
    on(UserActions.loadUsersFailure, (state, { error }) => ({
        ...state,
        error,
        loading: false
    })),

    // Add User
    on(UserActions.addUser, (state) => ({
        ...state,
        loading: true,
        error: null
    })),
    on(UserActions.addUserSuccess, (state, { user }) => ({
        ...state,
        users: [...state.users, user],
        loading: false
    })),
    on(UserActions.addUserFailure, (state, { error }) => ({
        ...state,
        error,
        loading: false
    })),

    // Update User
    on(UserActions.updateUser, (state) => ({
        ...state,
        loading: true,
        error: null
    })),
    on(UserActions.updateUserSuccess, (state, { user }) => ({
        ...state,
        users: state.users.map(u => u.id === user.id ? user : u),
        loading: false
    })),
    on(UserActions.updateUserFailure, (state, { error }) => ({
        ...state,
        error,
        loading: false
    })),

    // Delete User
    on(UserActions.deleteUser, (state) => ({
        ...state,
        loading: true,
        error: null
    })),
    on(UserActions.deleteUserSuccess, (state, { id }) => ({
        ...state,
        users: state.users.filter(u => u.id !== id),
        loading: false
    })),
    on(UserActions.deleteUserFailure, (state, { error }) => ({
        ...state,
        error,
        loading: false
    }))
);